const VersionReason = {
  SENT_TO_EDITOR: 'Sent to Editor',
  SENT_REVISIONS: 'Sent revisions',
  SENT_TO_CUSTOMER: 'Sent to Customer',
  SENT_FEEDBACK: 'Sent feedback',
  APPROVED: 'Approved',
  DRAFT_UPDATED: 'Draft updated',
  SENT_TO_DEVELOPMENTAL_EDITOR: 'Sent to Developmental Editor',
  VERSION_RESTORED: 'Version restored',
  SEND_TO_PROOFREAD: 'Sent to proofread',
  SENT_TO_PRO_PROOFREADER: 'Sent to Pro Proofreader',
};

module.exports = VersionReason;
